import { render } from "./HousingAssistance.vue?vue&type=template&id=159aa3c4&scoped=true"
import script from "./HousingAssistance.vue?vue&type=script&lang=js"
export * from "./HousingAssistance.vue?vue&type=script&lang=js"

import "./HousingAssistance.vue?vue&type=style&index=0&id=159aa3c4&scoped=true&lang=css"
import "./HousingAssistance.vue?vue&type=style&index=1&id=159aa3c4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-159aa3c4"]])

export default __exports__